import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Science.css";

function Science() {
  const [userGrade, setUserGrade] = useState(null);

  useEffect(() => {
    const userAge = parseInt(localStorage.getItem("userAge"), 10);
    if (userAge && userAge >= 6 && userAge <= 18) {
      setUserGrade(userAge - 5);
    }
  }, []);

  const gradeList = userGrade
    ? [
      <Link key={userGrade} to={`/science/grade${userGrade}`} className="science-grade-card">
        Grade {userGrade}
      </Link>,
    ]
    : [...Array(12)].map((_, index) => {
      const grade = index + 1;
      return (
        <Link key={grade} to={`/science/grade${grade}`} className="science-grade-card">
          Grade {grade}
        </Link>
      );
    });

  return (
    <div className="play2learn-science">
      <h1 className="science-title">Science Lessons</h1>
      <p className="science-description">
        {userGrade
          ? `Showing content for Grade ${userGrade}`
          : "Select a grade to start learning:"}
      </p>

      {/* === 工具入口區 === */}
      <div className="science-tools-bar" style={{ marginBottom: "1.2em" }}>
        <div className="science-tools-bar">
          <Link to="/science/vocab-practice" className="science-tool-btn vocab">
            <span className="emoji">🚀</span>Vocabulary Practice
          </Link>
          <Link to="/science/jeopardy" className="science-tool-btn jeopardy">
            <span className="emoji">🎲</span>Science Jeopardy
          </Link>
          <Link to="/science/chemistry-calc" className="science-tool-btn chem">
            <span className="emoji">🧪</span>Chemistry Calculation
          </Link>
          <Link to="/science/physics-calc" className="science-tool-btn physics">
            <span className="emoji">⚡</span>Physics Calculation
          </Link>
          <Link to="/science/biology-calc" className="science-tool-btn bio">
            <span className="emoji">🧬</span>Biology Calculation
          </Link>
          <Link to="/science/earth-calc" className="science-tool-btn earth">
            <span className="emoji">🌎</span>Earth Science Calculation
          </Link>
          <Link to="/science/advanced-chemistry" className="science-tool-btn bohr">
            <span className="emoji">🧲</span>Bohr Model Practice
          </Link>
        </div>
      </div>

      <div className="science-grade-container">{gradeList}</div>
    </div>
  );
}

export default Science;
